(() => {
  if (window.__storeCtaVideoInit) return;
  window.__storeCtaVideoInit = true;

  const VIDEO_SELECTOR = '[data-store-cta-video]';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const observe = (video) => {
    if (!video || video.dataset.observed === 'true') return;
    video.dataset.observed = 'true';

    // Respect reduced-motion: keep the poster, never load or play the video.
    if (reduceMotion) return;

    video.muted = true;

    const onIntersect = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          // preload="none" means bytes are only fetched once play() is called.
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }
    };

    const io = new IntersectionObserver(onIntersect, {
      rootMargin: '200px 0px',
      threshold: 0.1,
    });

    io.observe(video);
  };

  const init = () => {
    for (const video of document.querySelectorAll(VIDEO_SELECTOR)) observe(video);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();